import React from 'react';
import { useAuth } from '../context/AuthContext';
import SignInScreen from './SignInScreen';
import ListeningLibrary from './ListeningLibrary';

// Shell for the listening app. Watches Firebase auth state (via the app-wide
// AuthContext, which already runs a single onAuthStateChanged listener) and
// decides what to show:
//   - no signed-in user  -> the passwordless SignInScreen
//   - a signed-in user   -> their audiobook library
//
// Because SignInScreen exchanges the verified code for a real Firebase session
// (signInWithCustomToken), a successful sign-in flips AuthContext's `user`, this
// component re-renders, and the reader lands straight on their library. No
// manual navigation is needed inside the sign-in screen.
function ListeningApp() {
  const { user, isLoading } = useAuth();

  // Brief branded hold while the auth state resolves on first load, so we never
  // flash the sign-in screen at an already-signed-in reader.
  if (isLoading) {
    return (
      <div className="listening-theme min-h-screen w-full bg-background text-foreground flex items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-primary" />
      </div>
    );
  }

  if (!user) {
    return <SignInScreen />;
  }

  return <ListeningLibrary user={user} />;
}

export default ListeningApp;
